import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { UserService } from '../../_service/user.service';
import { SharedService } from '../../_service/shared.service';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { LeadsService } from '../../_service/leads.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, NgModel,FormGroup,Validators } from '@angular/forms';
declare var $: any;


@Component({
  selector: 'app-affiliate',
  templateUrl: './affiliate.component.html',
  styleUrls: ['./affiliate.component.css']
})
export class AffiliateComponent implements OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;

  perpage: number = 25; usersList: any = []; length: number = 0; pageEvent: PageEvent; loading: boolean = true;descriptionAddLoading: boolean = false; myrole: string;
  pageSizeOptions = [10, 25, 50, 100]; pageIndex: number = 0; loaded: boolean = false; search: string; currentUserId: any; status = '';
  booleanValue: any = false;descriptionForm: FormGroup;submitted:boolean=false;mark_as_affiliate:string;
  history_loading:boolean=true;history_loaded:boolean=false;updatedLodData=[];

  constructor(private formBuilder: FormBuilder,private userapi: UserService, private sharedapi: SharedService, public leadapi: LeadsService, private dialog: MatDialog) {
    this.descriptionForm = this.formBuilder.group({ 
      'user_id' : [null, Validators.required],
      'description' : [null, Validators.required],
    });

   }

  ngOnInit(): void {
    this.sharedapi.getRole().subscribe((item: string) => { this.myrole = item; });
    this.myrole = localStorage.getItem('role');
    this.currentUserId = localStorage.getItem('loginuserId');
    this.mark_as_affiliate = localStorage.getItem('mark_as_affiliate');
  }

  ngAfterViewInit() {
    this.loadUsersList(0, this.perpage);
  }

  get f() { return this.descriptionForm.controls; }

  hideUserDescriptionModal()
  {
      $('#myUserModelDescription').modal('hide');
  }

  async loadUsersList(pageIndex, perpage) {
    this.usersList = [];
    this.paginator.pageIndex = pageIndex;
    let qString = 'search=' + this.search + '&status=' + this.status;
    this.loading = true; this.loaded = false;
    this.userapi.getAffiliateUsers(this.paginator.pageIndex, perpage, qString).subscribe((data: any) => {
      this.length = parseInt(data.totaldata);
      this.loading = false;
      this.loaded = true;
      if (data.status) {
        this.usersList = data.data;
      } else {
        this.usersList = [];
        this.sharedapi.presentToast(data.msg);
      }
    }, error => {
      this.loading = false;
      this.loaded = true;
      this.sharedapi.checkError(error);
    });
  }


  pageChange(event) {
    this.pageIndex = event.pageIndex;
    this.loadUsersList(event.pageIndex, event.pageSize);
  }

  public getServerData(event: PageEvent): any {
    this.perpage = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.loadUsersList(event.pageIndex, event.pageSize);
  }

  resetFilters() {
    this.search = ''; this.status = '';
    this.loadUsersList(0, 25);
  }


  showUserDescriptionModal(userId,description) {
      this.descriptionForm.patchValue({
        'user_id':userId,  
        'description':description
    })
    $('#myUserModelDescription').modal(); 
  }

  async saveUserDescription(){
    this.submitted = true;
    this.descriptionAddLoading = true;
    if (this.descriptionForm.invalid) {
        this.descriptionAddLoading = false;
        return;
    }
    await this.userapi.addAffiliateUserDescription(this.descriptionForm.value)
      .subscribe((data:any) => {
        this.submitted = false;
        this.descriptionAddLoading = false;
        if(data.status){
            this.sharedapi.presentToast(data.msg); 
            this.hideUserDescriptionModal();
            this.loadUsersList(0,25); 
        }
        else{
            this.sharedapi.presentToast(data.msg);
        }
      }, error => 
        {
            this.sharedapi.checkError(error);
        }); 
  }

  openUserHistoryPopup(user_id)
  {
      this.history_loading = true;this.history_loaded = false;
      this.userapi.getFullAffiliateUserHistory(user_id).subscribe((data:any) => {
          this.history_loading = false;
          this.history_loaded = true;
          if(data.status)
          {
              this.updatedLodData = data.data;
          }else{
              this.updatedLodData = [];
          }
      }, error => {
              this.sharedapi.checkError(error);
      });
      $('#myHistoryModal').modal();
  }

  closeHistoryPopup()
  {
      $('#myHistoryModal').modal('hide');
  }




}
